export default function ChangeStatusConfirmationDialog({ isOpen, onClose, onConfirm }){
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 transition-all">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6 animate-fadeIn transform transition-transform duration-300">
        <div className="flex flex-col items-center text-center">
          <div className="bg-red-100 text-red-600 rounded-full p-3 mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h2 className="text-lg font-semibold text-gray-800 mb-2">Confirmation</h2>
          <p className="text-sm text-gray-600 mb-6">
            Are you sure you want to change the status?
          </p>
          <div className="flex justify-center gap-4 w-full">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 transition"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};